import { ORGANIZATION_PERMISSION_TYPE, PERMISSION_TYPE, PRIVATE_PAGE_ROUTES } from '@/enums';
import { CeremonyTemplateIcon } from '@/resources';
import {
  AdminIcon,
  BuildingsIcon,
  ChartIcon,
  DigitalSignageIcon,
  MonitorMobileIcon,
  Playlists,
  SidebarAssets,
  SidebarCalendarIcon,
  SidebarSettingsIcon,
  SidebarUserIcon
} from '@/resources/icons/sidebar';
import { SidebarConfigItem } from '@/types';

const ADMIN_TOOLS_PERMISSIONS = [
  PERMISSION_TYPE.GLOBAL_ACCESS,
  PERMISSION_TYPE.EVENT_ACCESS,
  PERMISSION_TYPE.ORG_ACCESS
];

export const sidebarConfig: SidebarConfigItem[] = [
  {
    icon: <AdminIcon className='mr-4 text-xl' />,
    label: 'adminTools',
    requiredPermissions: ADMIN_TOOLS_PERMISSIONS,
    children: [
      {
        label: 'dashboard',
        path: PRIVATE_PAGE_ROUTES.DASHBOARD,
        requiredPermissions: [PERMISSION_TYPE.VIEW_DASHBOARD]
      },
      {
        label: 'themes',
        path: PRIVATE_PAGE_ROUTES.THEMES,
        requiredPermissions: [PERMISSION_TYPE.VIEW_THEMES]
      },
      {
        label: 'stock-clips',
        path: PRIVATE_PAGE_ROUTES.STOCK_CLIPS,
        requiredPermissions: [PERMISSION_TYPE.VIEW_STOCK_CLIPS]
      },
      {
        label: 'payment-plans',
        path: PRIVATE_PAGE_ROUTES.PAYMENT_PLANS,
        requiredPermissions: [PERMISSION_TYPE.VIEW_PAYMENT_PLANS]
      },
      {
        label: 'player-releases',
        path: PRIVATE_PAGE_ROUTES.PLAYER_RELEASES,
        requiredPermissions: [PERMISSION_TYPE.VIEW_PLAYER_RELEASES]
      }
    ]
  },
  {
    icon: <ChartIcon className='mr-4 text-xl' />,
    label: 'dashboard',
    path: PRIVATE_PAGE_ROUTES.DASHBOARD,
    requiredPermissions: [PERMISSION_TYPE.VIEW_DASHBOARD],
    hiddenWhenAllPermissions: ADMIN_TOOLS_PERMISSIONS
  },
  {
    icon: <MonitorMobileIcon className='mr-4 text-xl' />,
    label: 'devices',
    path: PRIVATE_PAGE_ROUTES.DEVICES,
    requiredPermissions: [PERMISSION_TYPE.VIEW_DEVICES]
  },
  {
    icon: <SidebarUserIcon className='mr-4 text-xl' />,
    label: 'users',
    path: PRIVATE_PAGE_ROUTES.USERS,
    requiredPermissions: [PERMISSION_TYPE.VIEW_USERS]
  },
  {
    icon: <BuildingsIcon className='mr-4 text-xl' />,
    label: 'organizations',
    path: PRIVATE_PAGE_ROUTES.ORGANIZATIONS,
    requiredPermissions: [PERMISSION_TYPE.VIEW_ORGANIZATIONS]
  },
  {
    icon: <SidebarCalendarIcon className='mr-4 text-xl' />,
    label: 'events',
    path: PRIVATE_PAGE_ROUTES.EVENTS,
    requiredPermissions: [PERMISSION_TYPE.VIEW_EVENTS]
  },
  {
    icon: <Playlists className='mr-4 text-xl' />,
    label: 'playlists',
    path: PRIVATE_PAGE_ROUTES.PLAYLISTS,
    requiredPermissions: [PERMISSION_TYPE.VIEW_PLAYLISTS]
  },
  {
    icon: <CeremonyTemplateIcon className='mr-4 text-xl' />,
    label: 'ceremony-templates',
    path: PRIVATE_PAGE_ROUTES.CEREMONY_TEMPLATES,
    requiredPermissions: [PERMISSION_TYPE.VIEW_EVENT_TEMPLATES],
    requiredOrganizationPermissions: [ORGANIZATION_PERMISSION_TYPE.CEREMONY_SETUP]
  },
  {
    icon: <DigitalSignageIcon className='mr-4 text-xl' />,
    label: 'digital-signage',
    requiredPermissions: [PERMISSION_TYPE.ORG_ACCESS],
    requiredOrganizationPermissions: [ORGANIZATION_PERMISSION_TYPE.DIGITAL_SIGNAGE],
    children: [
      {
        label: 'device-management',
        path: PRIVATE_PAGE_ROUTES.DIGITAL_SIGNAGE_SCREENS
      },
      {
        label: 'playlists',
        path: PRIVATE_PAGE_ROUTES.DIGITAL_SIGNAGE_PLAYLISTS
      }
    ]
  },
  {
    icon: <SidebarAssets className='mr-4 text-xl' />,
    label: 'organization-assets',
    path: PRIVATE_PAGE_ROUTES.ORGANIZATION_ASSETS,
    requiredPermissions: [PERMISSION_TYPE.ORG_ACCESS],
    requiredOrganizationPermissions: [ORGANIZATION_PERMISSION_TYPE.MEDIA_LIBRARY]
  },
  {
    icon: <SidebarSettingsIcon className='mr-4 text-xl' />,
    label: 'settings',
    path: PRIVATE_PAGE_ROUTES.SETTINGS,
    requiredPermissions: [PERMISSION_TYPE.GLOBAL_ACCESS]
  }
];
